/* RUVR White Friday: countdown, side drawer, bar dismissal. One file for bar, drawer and hero. */
(function () {
  if (window.__ruvrSale) return;
  window.__ruvrSale = true;

  var d = document;
  var root = d.documentElement;
  var timer = null;
  var lastFocus = null;
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };

  function expire() {
    d.querySelectorAll('[data-wf]').forEach(function (el) { el.style.display = 'none'; });
    ['ruvr-wf-hide', 'ruvr-wf-header'].forEach(function (id) {
      var s = d.getElementById(id);
      if (s) s.remove();
    });
    root.classList.remove('rvsd-lock');
    if (timer) clearInterval(timer);
  }

  function tick() {
    var now = Date.now();
    var over = false;
    d.querySelectorAll('[data-wf-countdown]').forEach(function (el) {
      var ms = Number(el.getAttribute('data-wf-countdown')) * 1000 - now;
      if (ms <= 0) { over = true; return; }
      var s = Math.floor(ms / 1000);
      var v = { d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
      if (el.getAttribute('data-format') === 'tiles') {
        el.querySelectorAll('[data-unit]').forEach(function (u) {
          u.textContent = pad(v[u.getAttribute('data-unit')]);
        });
      } else {
        el.textContent = pad(v.d) + 'D ' + pad(v.h) + 'H ' + pad(v.m) + 'M ' + pad(v.s) + 'S';
      }
      el.classList.add('is-ready');
    });
    if (over) expire();
  }

  function setDrawer(open) {
    var panel = d.getElementById('ruvr-sale-drawer');
    if (!panel) return;
    var ov = d.querySelector('.rvsd-ov');
    var tab = d.querySelector('.rvsd-tab');
    panel.classList.toggle('is-open', open);
    if (ov) ov.classList.toggle('is-open', open);
    if (open) { panel.removeAttribute('inert'); } else { panel.setAttribute('inert', ''); }
    if (tab) tab.setAttribute('aria-expanded', open ? 'true' : 'false');
    root.classList.toggle('rvsd-lock', open);
    if (open) {
      lastFocus = d.activeElement;
      var c = panel.querySelector('[data-wf-close]');
      if (c) c.focus();
    } else if (lastFocus && lastFocus.focus) {
      lastFocus.focus();
    }
  }

  d.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-wf-open],[data-wf-close],[data-wf-dismiss],[data-wf-copy]') : null;
    if (!t) return;
    if (t.hasAttribute('data-wf-open')) {
      setDrawer(true);
    } else if (t.hasAttribute('data-wf-close')) {
      setDrawer(false);
    } else if (t.hasAttribute('data-wf-dismiss')) {
      var bar = t.closest('[data-wf-bar]');
      if (!bar) return;
      bar.style.display = 'none';
      try { localStorage.setItem('ruvr_wf_bar_' + bar.getAttribute('data-wf-key'), '1'); } catch (err) { /* storage blocked */ }
    } else if (t.hasAttribute('data-wf-copy')) {
      var label = t.textContent;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(t.getAttribute('data-wf-copy')).then(function () {
          t.textContent = 'Copied';
          setTimeout(function () { t.textContent = label; }, 1600);
        }).catch(function () { /* code stays selectable */ });
      }
    }
  });

  d.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') setDrawer(false);
  });

  tick();
  timer = setInterval(tick, 1000);
})();